import { ArrowUpRight } from "lucide-react";
import { useLang } from "../LanguageContext";
import { SIGNATURES, MENU_PDF } from "../content";
import { Reveal } from "./Reveal";

export const FeaturedDishes = () => {
  const { t, lang } = useLang();

  return (
    <section id="featured" className="bg-sand/40 py-24 md:py-36" data-testid="dishes-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 md:mb-20">
          <div>
            <Reveal>
              <p className="text-olive text-xs uppercase tracking-[0.35em] mb-6">{t.dishes.chapter}</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif text-brown text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                {t.dishes.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="text-brown/60 text-base md:text-lg max-w-sm font-light">{t.dishes.lead}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {SIGNATURES.map((dish, i) => (
            <Reveal key={dish.en} delay={(i % 4) * 0.08} y={50}>
              <article className="group" data-testid={`dish-card-${i}`}>
                <div className="relative aspect-[4/5] overflow-hidden rounded-xl bg-brown/5 shadow-lg shadow-brown/10">
                  <img
                    src={dish.img}
                    alt={lang === "pt" ? dish.pt : dish.en}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                    style={{ objectPosition: "center" }}
                  />
                </div>
                <h3 className="mt-4 font-serif text-brown text-lg md:text-xl leading-snug">
                  {lang === "pt" ? dish.pt : dish.en}
                </h3>
                <p className="text-brown/45 text-sm font-light">{lang === "pt" ? dish.en : dish.pt}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 md:mt-20 flex flex-col items-center gap-4">
            <p className="text-olive text-xs uppercase tracking-[0.35em]">{t.menuButtons.label}</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={MENU_PDF.en}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="menu-pdf-en"
                className="group inline-flex items-center justify-center gap-2 bg-brown text-ivory rounded-full px-8 py-[1.1rem] text-sm tracking-wide transition-[background-color,transform] duration-300 hover:bg-olive hover:-translate-y-0.5"
              >
                {t.menuButtons.en}
                <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
              <a
                href={MENU_PDF.pt}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="menu-pdf-pt"
                className="group inline-flex items-center justify-center gap-2 border border-brown/25 text-brown rounded-full px-8 py-[1.1rem] text-sm tracking-wide transition-[background-color,color,transform] duration-300 hover:bg-brown hover:text-ivory hover:-translate-y-0.5"
              >
                {t.menuButtons.pt}
                <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
